import { IconButton, styled, Box, Paper } from "@mui/material";
import Icons from "../../../../../assets/js/Icons";

const Image = styled("img")();
const File = styled("input")(() => ({ display: "none" }));

function Preview({ files, previews, setPreviews }) {

  const handlePreview = (e) => {
    const selected = Array.from(e.target.files);

    const allowed = ["pdf", "doc", "docx", "jpg", "jpeg", "png", "webp"];

    const validFiles = selected.filter((f) => {
      const ext = f.name.split(".").pop().toLowerCase();
      return allowed.includes(ext);
    });

    files.current = validFiles;

    const mapped = validFiles.map((file) => {
      const ext = file.name.split(".").pop().toLowerCase();

      if (["jpg", "jpeg", "png", "webp"].includes(ext)) {
        return {
          type: "image",
          url: URL.createObjectURL(file),
          name: file.name,
        };
      }

      return {
        type: ext,
        name: file.name,
      };
    });

    setPreviews(mapped);
  };

  const removeFile = (index) => {
    // remove from preview
    const newPreview = previews.filter((_, i) => i !== index);
    setPreviews(newPreview);

    // remove actual file
    files.current = files.current.filter((_, i) => i !== index);
  };

  return (
    <>
      <IconButton
        size="small"
        htmlFor="files"
        component="label"
        sx={{ "svg": { fontSize: 22 } }}
      >
        <Icons.AttachmentStrokeSharp />

        <File
          accept=".pdf,.doc,.docx,image/*"
          id="files"
          type="file"
          multiple
          onChange={handlePreview}
        />
      </IconButton>

      {Boolean(previews?.length) &&
        <Paper paperVariant="chatFilePreView">
          {previews?.map((item, idx) => (
            <Box key={idx} sx={{ position: "relative", borderRadius: 6 }}>
              {item?.type === "image" ?
                <Image src={item?.url} alt="preview" /> :
                <Paper paperVariant="filePostViewA" sx={{ aspectRatio: "auto" }}>
                  <Icons.ForumAll />
                  <span>{item?.type?.toUpperCase()}</span>
                </Paper>
              }

              <IconButton
                size="small"
                onClick={() => removeFile(idx)}
                variant="chatMediaRemove"
              ><Icons.Cross />
              </IconButton>
            </Box>
          ))}
        </Paper>
      }
    </>
  );
}

export default Preview;